/** Base path for the ConvoAI Spaces REST API. */
export const SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';
